import EditUserView from './edit-user'

const AddUserView = EditUserView.extend({
    edit: false,
})

export default AddUserView
